import React, { forwardRef, useImperativeHandle, useState, useEffect } from 'react'
import Select from 'react-select'
import { InputGroup } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList } from '@fortawesome/free-solid-svg-icons'
import '../../styles/Input/InputSelect.css'

{/*
<InputSelect
    theme={'light | dark'}
    ref={ref}
    data={}
    select={} setSelect={}
    selectError={} setSelectError={}
    icon={<FontAwesomeIcon icon={faT} />}
    value={}
    placeholder={""}
    multiple={false}
    nullable={false}
    onChange={() => }
/>
--inputTextLight: #ffffff;
--inputTextLightText: #49574b;
--inputTextDark: #eef5ef;
--inputTextDarkText: #49574b;
--inputTextSuccess: #435e48;
--inputTextError: #BB4040;
--inputSelectBorder: #dddddd;
*/}

const InputSelect = forwardRef((props, ref) => {

    useImperativeHandle(ref, () => ({ selectValidation: (values) => selectValidation(values) }))

    const [backgroundColor, setBackgroundColor] = useState(null)
    const [textColor, setTextColor] = useState(null)
    const [borderColor, setBorderColor] = useState(null)
    const [successBackgroundColor, setSuccessBackgroundColor] = useState(null)
    const [successTextColor, setSuccessTextColor] = useState(null)
    const [errorBackgroundColor, setErrorBackgroundColor] = useState(null)
    const [errorTextColor, setErrorTextColor] = useState(null)

    const selectStyle = {

        container: (baseStyles) => ({
            ...baseStyles,
            width: '100%',
        }),
        control: (baseStyles) => ({
            ...baseStyles,
            minHeight: '40px',
            height: 'auto',
            width: '100%',
            borderRadius: 20,
            textAlign: 'left',
            marginLeft: '-52px',
            paddingLeft: '50px',
            border: props.selectError == null ? '1px solid ' + borderColor : !props.selectError ? '2px solid ' + successTextColor : '2px solid ' + errorTextColor,
            backgroundColor: props.selectError == null ? backgroundColor : !props.selectError ? successBackgroundColor : errorBackgroundColor,
            color: props.selectError == null ? textColor : !props.selectError ? successTextColor : errorTextColor,
        }),
        menu: (baseStyles) => ({
            ...baseStyles,
            overflow: 'hidden',
            width: '100%',
            marginTop: '5px',
            marginLeft: '0',
            borderRadius: '10px',
            textAlign: 'left',
            backgroundColor: backgroundColor,
            color: textColor,
            zIndex: 9999,
            position: 'absolute',
        }),
        menuPortal: (baseStyles) => ({
            ...baseStyles,
            zIndex: 9999,
        }),
        placeholder: (baseStyles) => {
            return {
                ...baseStyles,
                color: '#505356',
            }
        },
        multiValue: (base) => ({
            ...base,
            borderRadius: '20px',
            padding: '0 5px',
        }),
        multiValueLabel: (base) => ({
            ...base,
            borderRadius: '20px 0 0 20px'
        }),
        multiValueRemove: (base) => ({
            ...base,
            borderRadius: '0 20px 20px 0'
        }),
        valueContainer: (base) => ({
            ...base,
            flexWrap: 'wrap',
            maxHeight: 'none',
            height: 'auto',
            padding: '2px 8px'
        })

    }

    useEffect(() => {

        getColors()

    }, [])

    function selectValidation(values) {

        if (props.multiple) {
            if (props.nullable && values && values.length === 0) {
                props.setSelectError(false)
                return true
            } else if (values && values.length > 0) {
                props.setSelectError(false)
                return true
            } else {
                props.setSelectError(true)
                return false
            }
        } else {
            if (props.nullable && values == null) {
                props.setSelectError(false)
                return true
            } else if (values && values.value.toString().length > 0) {
                props.setSelectError(false)
                return true
            } else {
                props.setSelectError(true)
                return false
            }
        }

    }

    function getColors() {

        if (props.theme === 'light') {
            setBackgroundColor(getComputedStyle(document.body).getPropertyValue('--inputTextLight'))
            setTextColor(getComputedStyle(document.body).getPropertyValue('--inputTextLightText'))
            setBorderColor(getComputedStyle(document.body).getPropertyValue('--inputSelectBorder'))
            setSuccessBackgroundColor(getComputedStyle(document.body).getPropertyValue('--inputTextLight'))
            setSuccessTextColor(getComputedStyle(document.body).getPropertyValue('--inputTextSuccess'))
            setErrorBackgroundColor(getComputedStyle(document.body).getPropertyValue('--inputTextLight'))
            setErrorTextColor(getComputedStyle(document.body).getPropertyValue('--inputTextError'))
        } else {
            setBackgroundColor(getComputedStyle(document.body).getPropertyValue('--inputTextDark'))
            setTextColor(getComputedStyle(document.body).getPropertyValue('--inputTextDarkText'))
            setBorderColor(getComputedStyle(document.body).getPropertyValue('--inputSelectBorder'))
            setSuccessBackgroundColor(getComputedStyle(document.body).getPropertyValue('--inputTextDark'))
            setSuccessTextColor(getComputedStyle(document.body).getPropertyValue('--inputTextSuccess'))
            setErrorBackgroundColor(getComputedStyle(document.body).getPropertyValue('--inputTextDark'))
            setErrorTextColor(getComputedStyle(document.body).getPropertyValue('--inputTextError'))
        }

    }

    return (

        <div className='inputSelectContainer' style={{ paddingBottom: 0 }}>
            <InputGroup.Text className={['inputSelectIcon', props.disabled ? 'inputSelectIconDisabled' : props.theme === 'light' ? 'inputSelectIconLight' : 'inputSelectIconDark', props.selectError === false ? 'inputSelectIconSuccess' : props.selectError ? 'inputSelectIconError' : null].join(" ")}>
                {props.icon ? props.icon : <FontAwesomeIcon icon={faList} />}
            </InputGroup.Text>
            <Select
                options={props.data}
                value={props.select ? props.select : props.value}
                placeholder={props.placeholder}
                isMulti={props.multiple}
                onChange={(value) => props.onChange ? (props.setSelect(value), selectValidation(value), props.onChange(value)) : (props.setSelect(value), selectValidation(value))}
                className={['inputSelect', props.disabled ? 'inputSelectDisabled' : null].join(" ")}
                classNamePrefix="mySelect"
                styles={selectStyle}
                isDisabled={props.disabled}
                menuPortalTarget={document.body}
            />
        </div>


    )

})

export default InputSelect
